import { useState, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { CrmSidebar } from "./CrmSidebar";
import { VoicePanel, VoicePanelToggle } from "@/components/voice/VoicePanel";

// DEM-37: route-based chrome ported from my-jarvis-dashboard-erez so KB pages
// match the erez tenant standard — sky-blue main background + narrow reading
// column on /kb-doc/*.
const SKY_BLUE_BG = "#F2F7FD";

// DEM-40: extend chrome to /paamon and /clinic operational pages so they
// share the same blue + narrow column with KB pages (consistent feel,
// less scroll-to-content because Layout's compact padding replaces the
// page-level py-14 padding the operational pages used to ship).
const SKY_BLUE_ROUTES = ["/kb-doc", "/knowledge-base", "/paamon", "/clinic", "/shir-derech"];

const NARROW_ROUTES = ["/kb-doc", "/paamon", "/clinic", "/shir-derech"];

function matchesRoute(pathname: string, routes: string[]): boolean {
  return routes.some((r) => pathname === r || pathname.startsWith(r + "/"));
}

export const Layout = ({ children }: { children: ReactNode }) => {
  const [voicePanelOpen, setVoicePanelOpen] = useState(true);
  const location = useLocation();
  const customBg = matchesRoute(location.pathname, SKY_BLUE_ROUTES)
    ? SKY_BLUE_BG
    : null;
  const narrow = matchesRoute(location.pathname, NARROW_ROUTES);

  const contentClass = narrow
    ? "mx-auto w-full max-w-[1000px] px-4 py-8 sm:px-8 sm:py-10 md:px-12"
    : "mx-auto max-w-6xl px-6 py-8";

  return (
    <div className="flex h-svh">
      <CrmSidebar />
      <main
        className={`relative flex-1 overflow-auto ${customBg ? "" : "bg-background"}`}
        style={customBg ? { background: customBg } : undefined}
      >
        {!voicePanelOpen && (
          <div className="pointer-events-none absolute inset-x-0 top-0 z-30 flex justify-end px-6 py-4">
            <div className="pointer-events-auto">
              <VoicePanelToggle onClick={() => setVoicePanelOpen(true)} />
            </div>
          </div>
        )}
        <div className={contentClass}>{children}</div>
      </main>
      <VoicePanel open={voicePanelOpen} onClose={() => setVoicePanelOpen(false)} />
    </div>
  );
};
